<template>
  <div id="app">
    <transition name="loader-fade">
      <div v-if="loading" class="loader">
        <!-- Fondo futurista -->
        <div class="loader-bg-grid" aria-hidden="true"></div>
        <div class="loader-glow-orb glow-cyan" aria-hidden="true"></div>
        <div class="loader-glow-orb glow-blue" aria-hidden="true"></div>

        <div class="loader-content">
          <!-- Anillos cibernéticos y logo -->
          <div class="loader-ring-wrapper">
            <div class="loader-orbital-ring ring-outer"></div>
            <div class="loader-orbital-ring ring-inner"></div>
            <div class="loader-core-glow"></div>
            <img
              src="@/assets/Img/Logo_Navar/logo_sin_fondo_recortado.png"
              alt="Logo Jean Informático"
              class="loader-logo-img"
            />
          </div>

          <!-- Barra de carga futurista con status -->
          <div class="loader-progress-box">
            <div class="loader-progress-track">
              <div class="loader-progress-bar"></div>
            </div>
            <div class="loader-text">
              <span class="loader-status-dot"></span>
              <span>CARGANDO SISTEMA</span>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div v-show="!loading" class="main-content">
      <router-view />
      <AsistenteOrdenModal ref="asistente" :auto-open="false" />
    </div>
  </div>
</template>

<script>
import AsistenteOrdenModal from '@/components/AsistenteOrdenModal.vue';

export default {
  components: {
    AsistenteOrdenModal
  },
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1200);
  }
}
</script>

<style>
html {
  scroll-behavior: smooth;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  min-height: 100vh;
}

.main-content {
  opacity: 1;
  transition: opacity 0.4s ease;
}

/* ============================================================
   LOADER FUTURISTA DE ALTO RENDIMIENTO
   ============================================================ */
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 50% 50%, #0a1c2e 0%, #030812 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  overflow: hidden;
}

/* Grid tecnológico sutil */
.loader-bg-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0, 229, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 229, 255, 0.05) 1px, transparent 1px);
  background-size: 38px 38px;
  pointer-events: none;
}

/* Orbes de luz ambiental */
.loader-glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  pointer-events: none;
  opacity: 0.45;
}

.glow-cyan {
  width: 420px;
  height: 420px;
  background: #00e5ff;
  top: 20%;
  left: 20%;
  animation: orbPulse 4s ease-in-out infinite alternate;
}

.glow-blue {
  width: 480px;
  height: 480px;
  background: #1a73e8;
  bottom: 15%;
  right: 20%;
  animation: orbPulse 5s ease-in-out infinite alternate-reverse;
}

/* Contenedor central */
.loader-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.2rem;
}

/* Envoltorio con anillos orbitales */
.loader-ring-wrapper {
  position: relative;
  width: 320px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Anillo exterior discontinuo */
.loader-orbital-ring.ring-outer {
  position: absolute;
  width: 290px;
  height: 210px;
  border-radius: 50%;
  border: 1.5px dashed rgba(0, 229, 255, 0.35);
  animation: ringSpin 14s linear infinite;
  box-shadow: 0 0 20px rgba(0, 229, 255, 0.12);
}

/* Anillo interior tecnológico giratorio */
.loader-orbital-ring.ring-inner {
  position: absolute;
  width: 250px;
  height: 180px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #00e5ff;
  border-bottom-color: #1a73e8;
  animation: ringSpinReverse 3.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  filter: drop-shadow(0 0 8px #00e5ff);
}

/* Núcleo de resplandor central */
.loader-core-glow {
  position: absolute;
  width: 170px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 229, 255, 0.3) 0%, transparent 70%);
  filter: blur(14px);
  animation: corePulse 2s ease-in-out infinite alternate;
}

/* Logo elegante y nítido */
.loader-logo-img {
  position: relative;
  z-index: 3;
  max-width: 240px;
  width: 85%;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 0 22px rgba(0, 229, 255, 0.6)) drop-shadow(0 6px 14px rgba(0, 0, 0, 0.8));
  animation: logoBreath 2.2s ease-in-out infinite alternate;
}

/* Barra de progreso y texto de carga */
.loader-progress-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  width: 220px;
}

.loader-progress-track {
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 99px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.loader-progress-bar {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, #00e5ff, #7ef0ff, #1a73e8, transparent);
  background-size: 200% 100%;
  animation: progressFlow 1.6s ease-in-out infinite;
}

.loader-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 2.5px;
  color: #a0c4ff;
  text-transform: uppercase;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-shadow: 0 0 10px rgba(0, 229, 255, 0.5);
}

.loader-status-dot {
  width: 6px;
  height: 6px;
  background-color: #00e676;
  border-radius: 50%;
  box-shadow: 0 0 8px #00e676;
  animation: dotFlash 0.9s infinite alternate;
}

/* Transición suave al salir del loader */
.loader-fade-leave-active {
  transition: opacity 0.45s ease, transform 0.45s ease;
}

.loader-fade-leave-to {
  opacity: 0;
  transform: scale(1.02);
}

/* Keyframes de animación acelerados por GPU */
@keyframes ringSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes ringSpinReverse {
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
}

@keyframes logoBreath {
  0% { transform: scale(0.97); }
  100% { transform: scale(1.03); }
}

@keyframes corePulse {
  0% { opacity: 0.4; transform: scale(0.9); }
  100% { opacity: 0.9; transform: scale(1.15); }
}

@keyframes orbPulse {
  0% { transform: translate(0, 0) scale(0.9); opacity: 0.35; }
  100% { transform: translate(20px, -20px) scale(1.1); opacity: 0.55; }
}

@keyframes progressFlow {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes dotFlash {
  0% { opacity: 0.3; transform: scale(0.8); }
  100% { opacity: 1; transform: scale(1.2); }
}

/* Ajustes Responsive */
@media (max-width: 600px) {
  .loader-ring-wrapper {
    width: 260px;
    height: 170px;
  }
  .loader-orbital-ring.ring-outer {
    width: 240px;
    height: 170px;
  }
  .loader-orbital-ring.ring-inner {
    width: 210px;
    height: 150px;
  }
  .loader-logo-img {
    max-width: 200px;
  }
  .loader-progress-box {
    width: 180px;
  }
}
</style>
